import {
  getMappedComparisonRelation,
  type PLAYER_PORTALS_MODELS,
} from '@r-and-a-shared-ui/common-kontent-client';

export const relation_item = (data: PLAYER_PORTALS_MODELS.RelationItem) => {
  if (!data || !data?.elements) {
    return undefined;
  }

  const { elements } = data;

  return {
    value: elements?.value?.value,
    relation: getMappedComparisonRelation(elements?.relation),
  };
};

export default relation_item;
